import { useForm } from '@mantine/form';

import { TSDViewHouseFormValues } from '@e-origin/contracts';

export const useTSDViewHouseFormInitializer = ({ houseConsignmentIdx, consignmentForm, isMaster, onSave, onHide }) => {
  const houseConsignment = isMaster ? consignmentForm?.values?.master : consignmentForm?.values?.houseConsignment?.[houseConsignmentIdx];

  const buildPersonValues = (person) => ({
    identificationNumber: person?.identificationNumber || '',
    name: person?.name || '',
    status: person?.status || '',
    typeOfPerson: person?.typeOfPerson || '',
    communication: {
      phoneNumber: person?.communication?.phoneNumber || '',
      eMailAddress: person?.communication?.eMailAddress || '',
    },
    address: {
      street: person?.address?.street || '',
      streetAdditionalLine: person?.address?.streetAdditionalLine || '',
      number: person?.address?.number || '',
      poBox: person?.address?.poBox || '',
      subDivision: person?.address?.subDivision || '',
      country: person?.address?.country || '',
      postcode: person?.address?.postcode || '',
      city: person?.address?.city || '',
    },
  });

  const buildHouseValues = (house) => ({
    referenceNumberUCR: house?.referenceNumberUCR || '',
    totalGrossMass: house?.totalGrossMass || '',
    totalNumberOfPackages: house?.totalNumberOfPackages || '',
    consignor: buildPersonValues(house?.consignor),
    consignee: buildPersonValues(house?.consignee),
    notifyParty: buildPersonValues(house?.notifyParty),
    additionalSupplyChainActor: (house?.additionalSupplyChainActor ?? []).map((additionalSupplyChainActor) => ({
      role: additionalSupplyChainActor.role || '',
      identificationNumber: additionalSupplyChainActor.identificationNumber || '',
    })),
    transportEquipment: (house?.transportEquipment ?? []).map((transportEquipment) => ({
      containerIdentificationNumber: transportEquipment.containerIdentificationNumber || '',
      containerPackedStatus: transportEquipment.containerPackedStatus || '',
      numberOfSeals: transportEquipment.numberOfSeals || '',
      seal: (transportEquipment?.seal ?? []).map((seal) => ({
        identifier: seal.identifier || '',
      })),
    })),
    receptacle: (house?.receptacle ?? []).map((receptacle) => ({
      identificationNumber: receptacle?.identificationNumber,
    })),
    transportDocuments: (house?.transportDocuments || []).map((transportDocument) => ({
      type: transportDocument.type || '',
      referenceNumber: transportDocument.referenceNumber || '',
    })),
    previousDocuments: (house?.previousDocuments || []).map((previousDocument) => ({
      type: previousDocument.type || '',
      referenceNumber: previousDocument.referenceNumber || '',
      goodsItemIdentifier: previousDocument.goodsItemIdentifier || '',
    })),
    additionalInformation: (house?.additionalInformation || []).map((additionalInformation) => ({
      code: additionalInformation.code || '',
      text: additionalInformation.text || '',
    })),
    supportingDocuments: (house?.supportingDocuments || []).map((supportingDocument) => ({
      type: supportingDocument.type || '',
      referenceNumber: supportingDocument.referenceNumber || '',
    })),
    batches: (house?.batches || []).map((batch) => ({
      id: batch.id || '',
      name: batch.name || '',
    })),
  });

  const houseForm = useForm<TSDViewHouseFormValues>({
    initialValues: buildHouseValues(houseConsignment),
  });

  const onSubmit = async () => {
    onSave(houseForm.values, isMaster);
    onHide();
  };

  return { buildHouseValues, houseForm, onSubmit };
};
